import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import AddKidWarningPage from './AddKidWarningPage';

const AddKidWarningRoute: FuseRouteItemType = {
  path: '',
  element: <AddKidWarningPage />,
};

export default AddKidWarningRoute;
